import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { queueGTMEvent } from '@/lib/gtm';
import { startJourneyTracking, trackJourneyEvent } from '@/lib/visitorJourney';
import { sessionRequests } from '@/lib/auth/sessionRequests';
import { useOptionalSession } from '@/lib/auth/SessionManager';

export default function AnalyticsRouteListener() {
  const location = useLocation();
  const session = useOptionalSession();
  const userId = session?.user?.id;
  useEffect(() => {
    if (userId && session?.requestsReady) trackJourneyEvent('identity', 'authenticated');
  }, [userId, session?.requestsReady]);

  useEffect(() => {
    const pagePath = location.pathname + location.search;

    const pageViewEvent = {
      event: 'page_view',
      page_location: window.location.href,
      page_path: pagePath,
      page_title: document.title,
    };

    // Use the queue system to ensure events are captured even if GTM isn't ready
    queueGTMEvent(pageViewEvent);
    return startJourneyTracking(pagePath, () => sessionRequests.getCredentials().accessToken);
  }, [location.pathname, location.search]);

  return null;
}
